import { NotAvailableCommonElements } from '@upright/ui/common/upright/iam/access/feature-access/not-available-content/types';
import { FeatureId } from '../../../../../common/iam/access/feature-access/types';
import { FeatureAccessEmptyState } from '@upright/ui/common/generic/components/not-available-section';
import { StandaloneModal } from '@upright/ui/common/generic/modals/standalone-modal';

interface Props {
  modalOpen?: boolean;
  setModalOpen: (open: boolean) => void;
  featureId: FeatureId;
  customContent?: NotAvailableCommonElements;
}

export const NotAvailableModal = (props: Props) => {
  return (
    <StandaloneModal
      {...{
        isOpen: props.modalOpen || false,
        closeModal: () => {
          props.setModalOpen(false);
        },
        modalName: 'Feature not available',
      }}
    >
      <NotAvailableModalContent {...props} />
    </StandaloneModal>
  );
};

export const NotAvailableModalContent = (props: Props) => {
  const { featureId, customContent } = props;
  return <FeatureAccessEmptyState {...{ featureId, customContent }} />;
};
